// extracted by mini-css-extract-plugin
export default {"container":"IQ-z","darkBackground":"JQ-z","whiteBackground":"KQ-z","headerButton":"LQ-z","calloutHeading":"MQ-z","calloutSubHeading":"NQ-z"};